module.exports = __webpack_public_path__ + "images/01f01968.img4-kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img4-kor.png
// module id = 409
// module chunks = 0